import { Toast, Dialog } from 'vant';
import wx from 'jweixin-1.6.0';
import comment from "../../util/comment"

export default {
    data() {
        return {
            checked: [],
            checkboxGroup: null,
            checkboxRefs: [],
            vote_checked_state: false,
            time: (30 * 60 * 60 * 1000),
            active: 0,
            openId: '',
            voteDatas: {},
            voteTitle_t: '',
            voteTitle_p: '',
            vote_itemNos: [],
            loading: false,
            appId: '',
            timestamp: '',
            nonceStr: '',
            signature: '',
            jsapi_ticket: '',
            url: '',
            errmsg: '',
            errurl: '',

            codeStr: '', //静默授权的code
            curOpenId: '', //微信openId
            accessToken: '',  //accessToken
            nickName: '',  //微信昵称
            headIngUrl: '',  //微信头像

            memberId: '', //会员ID
            isAuthor: '', //0：APP访问  1：微信访问
            voteId: '', //投票ID

        };
    },

    mounted() {
        this.codeStr = comment.GetQueryString("code");
        this.memberId = comment.GetQueryString("memberId");

        this.voteId = comment.GetQueryString("voteId").split('_')[0];
        this.isAuthor = comment.GetQueryString("voteId").split('_')[1];

        if (this.memberId == null || this.memberId == '') { //没有会员ID，可能是老版本APP或者是微信打开的
            if (this.isAuthor == null || this.isAuthor == '' || this.isAuthor == 0 || this.isAuthor == undefined) { //是APP打开的
                Dialog.alert({
                    title: '友情提醒',
                    message: '您当前的版本不是最新版本，请到应用市场下载最新的版本',
                }).then(() => {

                    location.href = "http://www.danyang.com/download.html"
                });
            }
        }

        if ((this.memberId == null || this.memberId == '') && this.isAuthor == 1) {
            if (this.codeStr == null || this.codeStr == "") {
                this.linkRedirect();
            }
        }

        if (this.codeStr != null && this.codeStr != "") {

            // this.getOauthAppId(); //静默授权获取openId
            this.getAccessTokenByCode(); //静默授权获取openId
        }
        this.getVoteItems();
        // this.getOpenIdByCode();  //先注释
        // this.getShareNeedsParam();

        // if (this.isEmpty(null) && this.isEmpty(undefined)) {


        // if (this.isEmpty(this.$route.query.code) && this.isEmpty(this.$route.query.memberId)) {
        //     Dialog.alert({
        //         title: '友情提醒',
        //         message: '您当前的版本不是最新版本，请到应用市场下载最新的版本',
        //     }).then(() => {
        //
        //         location.href = "http://www.danyang.com/download.html"
        //     });
        // }

    },
    methods: {
        onRefresh() {
            setTimeout(() => {
                // Toast('刷新成功');
                // console.log(this.loading.value, "this.loading")

                this.getVoteItems();
                this.loading = false;
                // console.log(this.loading, "this.loading")
            }, 500);
        },
        linkRedirect() {
            // let linkedUrl = 'http://mydyac.sipyun.com/?voteId=1_1'; //当前页面Url
            let linkedUrl = comment.linkedUrl; //当前页面Url

            // window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + comment.wxAppId +
            //     "&redirect_uri=" + linkedUrl +
            //     "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";

            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + comment.wxAppId +
                "&redirect_uri=" + linkedUrl +
                "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
        },


        // getOauthAppId() {
        //
        //     if (this.codeStr != null && this.codeStr != "") {
        //
        //         this.codeStr = comment.GetQueryString("code"); //静默授权的code
        //         var params = {
        //             code: this.codeStr
        //         };
        //         this.$api.getOauthAppId({
        //             params: params,
        //
        //             success: function(res) {
        //                 if (res.code == 0) {
        //                     this.curOpenId = res.data.openid;
        //
        //                     this.getShareNeedsParam();
        //                 }
        //
        //             }.bind(this),
        //             fail: function(res) {
        //                 Toast.fail({ message: res.msg });
        //
        //             }
        //         })
        //     }
        // },

        getAccessTokenByCode() {

            if (this.codeStr != null && this.codeStr != "") {

                this.codeStr = comment.GetQueryString("code"); //静默授权的code

                var params = {
                    code: this.codeStr
                };
                this.$api.getAccessTokenByCode({
                    params: params,

                    success: function(res) {
                        if (res.code == 0) {
                            this.curOpenId = res.data.openId;
                            this.accessToken = res.data.accessToken;

                            this.getShareNeedsParam();

                            if(this.curOpenId != '' && this.accessToken != ''){
                                this.getWxUserInfo();  //获取微信昵称和头像
                            }
                        }

                    }.bind(this),
                    fail: function(res) {
                        Toast.fail({ message: res.msg });

                    }
                })
            }
        },

        getWxUserInfo() {

            if (this.codeStr != null && this.codeStr != "") {

                var params = {
                    openId: this.curOpenId,
                    accessToken: this.accessToken
                };
                this.$api.getWxUserInfo({
                    params: params,

                    success: function(res) {

                        if (res.code == 0) {
                            this.nickName = res.data.nickName;
                            this.headImgUrl = res.data.headImgUrl;
                        }

                    }.bind(this),
                    fail: function(res) {
                        Toast.fail({ message: res.msg });

                    }
                })
            }
        },


        isEmpty(data) {
            if (data == null || data == '' || data == undefined) {
                return true;
            } else {
                return false;
            }
        },

        reset() {
            this.vote_itemNos = [];
            this.checked = [];

            console.log(this.$refs.checkboxes);
            // this.$refs.checkboxes.map(item => {
            //     return item.checked = false;
            // })
        },
        getShareNeedsParam: function() {
            let curUrl = window.location.href; //获取当前页面的完整路径
            curUrl = curUrl.split('#')[0];

            var params = {
                curUrl: curUrl
            };
            console.log(params, "params");
            this.$api.getShareNeedsParam({
                params: params,

                success: function(res) {
                    this.appId = res.data.appId;
                    this.timestamp = res.data.timestamp;
                    this.nonceStr = res.data.nonceStr;
                    this.signature = res.data.signature;

                    if (res.code == 0) {
                        //------------------------分享用代码-----------------------
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: this.appId, // 必填，公众号的唯一标识
                            timestamp: this.timestamp, // 必填，生成签名的时间戳
                            nonceStr: this.nonceStr, // 必填，生成签名的随机串
                            signature: this.signature, // 必填，签名
                            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
                        });

                        this.shareWx();

                        console.log(":::success", res);
                    } else {
                        // Toast.fail('提交失败', res.msg);
                        Toast.fail({ message: res.msg });
                        console.log(res.msg);
                    }

                }.bind(this),
                fail: function(res) {
                    Toast.fail({ message: res.msg });

                }
            })
        },


        shareWx: function() {
            let curUrl = window.location.href; //获取当前页面的完整路径
            // let curUrl = 'http://mydyws.sipyun.com/mydy/activeView/vote/1'; //获取当前页面的完整路径
            curUrl = curUrl.split('#')[0];

            //分享好友
            wx.ready(function() { //需在用户可能点击分享按钮前就先调用

                // let curImgUrl = basicImgUrl;

                wx.updateAppMessageShareData({
                    title: '我的丹阳APP宣传标语投票', // 分享标题
                    desc: '我的丹阳', // 分享描述
                    link: curUrl,
                    imgUrl: 'http://ws.danyang.com/mydy/img/mydyLogo.png', // 分享图标
                    success: function() {
                        // alert('朋友分享成功');
                    }
                });

                // 注册分享朋友事件
                wx.updateTimelineShareData({
                    title: '我的丹阳APP宣传标语投票', // 分享标题
                    desc: '我的丹阳',
                    link: curUrl, // 分享链接，该链接域名必须与当前企业的可信域名一致
                    imgUrl: 'http://ws.danyang.com/mydy/img/mydyLogo.png', // 分享图标
                    success: function() {
                        // alert('朋友圈分享成功');
                    }
                });

            });
            //------------------------分享用代码-----------------------
        },

        groupclick(event) {
            // console.log(event, "event")
            let arr = []
            event.forEach(item => {
                arr.push(item.voteItemNo)
            })

            this.vote_itemNos = arr;

        },

        getVoteItems: function() {
            this.$api.getVoteItems({
                params: {
                    // 'voteId': '1',
                    // 'voteId': this.$route.query.voteId,
                    'voteId': this.voteId,
                    'type': "1"
                },
                success: function(res) {

                    this.voteDatas = res.data;
                    this.voteTitle_t = res.data.voteTitle.slice(0, 11);
                    this.voteTitle_p = res.data.voteTitle.slice(11, 15);

                }.bind(this),
                fail: function(res) {
                    console.log(":::fail", res)

                }
            })
        },
        saveVoteInfo: function() {
            // console.log(this.openId, "openId");
            // var params = {
            //     "voteId": "1",
            //     "memberId": "6",
            //     "openId": "",
            //     "itemNos": this.vote_itemNos
            // };
            var params = {
                // "voteId": this.$route.query.voteId,
                "voteId": this.voteId,
                "memberId": this.$route.query.memberId,
                // "openId": this.openId,
                "openId": this.curOpenId,
                "wxNickName": this.nickName,
                "wxHeadImgUrl": this.headImgUrl,
                "itemNos": this.vote_itemNos
            };
            // console.log(params, "params")
            if (this.vote_itemNos.length <= 0) {
                Toast.fail('请至少投票一条标语');
                return false
            }
            this.reset();

            this.$api.saveVoteInfo({
                params: params,

                success: function(res) {
                    if (res.code == 0) {
                        console.log(":::success", res);
                        Toast.success('提交成功');
                        this.getVoteItems();
                    } else {
                        // Toast.fail('提交失败', res.msg);
                        Toast.fail({ message: res.msg });
                        console.log(res.msg);
                    }
                    this.reset();


                }.bind(this),
                fail: function(res) {
                    Toast.fail({ message: res.msg });

                }
            })
        },


        getOpenIdByCode: function() {
            if (this.$route.query.code != '' && this.$route.query.code != null) {
                this.$api.getOpenIdByCode({
                    params: {
                        // "code": ''
                        "code": this.$route.query.code
                    },

                    success: function(res) {
                        if (res.code == 0) {
                            console.log(":::success open", res);
                            this.openId = res.data;

                            // Toast.success('提交成功');
                        } else {
                            Toast.fail({ message: res.msg });
                            console.log(res.msg);
                        }

                    }.bind(this),
                    fail: function(res) {
                        Toast.fail({ message: res.msg });

                    }
                })
            }
        },



    }
};
